const defaults = require('./defaults');

module.exports = {
  ...defaults,
  serviceApiRoot: 'https://development.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://development.services.lsapis.com.au/graphql',
  hot: true,
  urlRoot: `http://localhost:${defaults.port}`,
  b2bApiRoot: 'https://lsb2bstaging.wpengine.com',
  imageResizeRoot: 'https://dkw8fcvpqki80.cloudfront.net',
  token: {
    ...defaults.token,
    cookie: {
      domain: 'localhost',
    },
  },
  elastic: {
    ...defaults.elastic,
    node:
      'https://vpc-ls-services-development-hbhodal3fc26ckeb3zs2iikmeq.ap-southeast-2.es.amazonaws.com',
  },
  auth: {
    ...defaults.auth,
    redirectUri: `http://localhost:${defaults.port}/login-loader`,
    returnTo: `http://localhost:${defaults.port}`,
  },
  logger: {
    ...defaults.logger,
    console: {
      level: 'error',
    },
  },
};
